export const THEME_OPTIONS = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
}

export const THEME_STORAGE_KEY = 'jp_theme_mode'

export const getStoredThemeMode = () => {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY)
    if (value === THEME_OPTIONS.LIGHT || value === THEME_OPTIONS.DARK || value === THEME_OPTIONS.SYSTEM) {
      return value
    }
  } catch {}
  return THEME_OPTIONS.SYSTEM
}

export const getSystemTheme = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return THEME_OPTIONS.LIGHT
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_OPTIONS.DARK : THEME_OPTIONS.LIGHT
}

export const resolveTheme = (mode) => (mode === THEME_OPTIONS.SYSTEM ? getSystemTheme() : mode)

export const persistThemeMode = (mode) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode)
  } catch {}
}

export const getThemeColors = (theme) => {
  if (theme === THEME_OPTIONS.DARK) {
    return {
      bg: '#0b1220',
      white: '#111827',
      blue: '#60A5FA',
      blueLight: '#172554',
      text: '#F8FAFC',
      muted: '#94A3B8',
      subtle: '#64748B',
      border: '#243041',
      green: '#4ADE80',
      greenBg: '#052e1b',
      greenBorder: '#166534',
      amber: '#FBBF24',
      amberBg: '#3b2a06',
      amberBorder: '#92400e',
      red: '#F87171',
      redBg: '#3b0a0a',
      redBorder: '#991b1b',
      purple: '#A78BFA',
      purpleBg: '#2e1065',
      purpleBorder: '#6d28d9',
      orange: '#FB923C',
      orangeBg: '#431407',
      orangeBorder: '#9a3412',
      shadow: '0 10px 30px rgba(0,0,0,0.35)',
    }
  }

  return {
    bg: '#F7F6F2',
    white: '#fff',
    blue: '#2563EB',
    blueLight: '#EFF6FF',
    text: '#0f172a',
    muted: '#64748b',
    subtle: '#94a3b8',
    border: '#e5e7eb',
    green: '#15803d',
    greenBg: '#F0FDF4',
    greenBorder: '#86EFAC',
    amber: '#b45309',
    amberBg: '#fffbeb',
    amberBorder: '#FCD34D',
    red: '#dc2626',
    redBg: '#FEF2F2',
    redBorder: '#FECACA',
    purple: '#5b21b6',
    purpleBg: '#ede9fe',
    purpleBorder: '#C4B5FD',
    orange: '#c2410c',
    orangeBg: '#FFF7ED',
    orangeBorder: '#FED7AA',
    shadow: '0 8px 24px rgba(15,23,42,0.08)',
  }
}
